export default __webpack_public_path__ + "static/fixed_assets-eccb0ff5446c606b6bdf13019244ffc8.png";